import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import "./FloatingContact.css";

const FloatingContact = () => {
  const [isEnquiryModalVisible, setIsEnquiryModalVisible] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [sendResult, setSendResult] = useState("");
  const formRef = useRef();

  // EmailJS Send Function
  const sendEmail = (e) => {
    e.preventDefault();
    setIsSending(true);
    setSendResult("");

    const serviceId = "service_cys1qdu";
    const templateId = "template_u738we8";
    const publicKey = "hmZvaHSmtPHQTidlV";

    emailjs.sendForm(serviceId, templateId, formRef.current, publicKey).then(
      (result) => {
        setIsSending(false);
        setSendResult("success");

        // --- META PIXEL EVENT TRACKING START ---
        // We check if window.fbq exists to prevent React errors if the base code fails to load
        if (typeof window !== "undefined" && window.fbq) {
          console.log("Firing Meta Events: Lead & AddToCart");
          window.fbq("track", "Lead");
          window.fbq("track", "AddToCart");
        } else {
          console.warn("Meta Pixel (fbq) is not defined.");
        }
        // --- META PIXEL EVENT TRACKING END ---

        setTimeout(() => {
          setIsEnquiryModalVisible(false);
          setSendResult("");
        }, 3000);
      },
      (error) => {
        setIsSending(false);
        setSendResult("error");
        console.error(error.text);
      },
    );
  };

  return (
    <>
      {/* FLOATING WHATSAPP BUTTON */}
      <a
        href="https://wa.me/+919225088164?text=Hello%20Mango%20Holidays!%20I%20would%20like%20to%20know%20more%20about%20your%20tours."
        className="floating-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <i className="fa-brands fa-whatsapp"></i>
      </a>

      {/* FLOATING QUICK ENQUIRY BUTTON */}
      <div
        className="floating-enquiry-btn"
        onClick={() => setIsEnquiryModalVisible(true)}
      >
        <i className="fa-regular fa-envelope"></i>
        <span>Quick Enquiry</span>
      </div>

      {/* ENQUIRY MODAL FORM */}
      {isEnquiryModalVisible && (
        <div
          className="enquiry-modal-overlay fadeIn"
          onClick={() => setIsEnquiryModalVisible(false)}
        >
          <div
            className="enquiry-modal-content slideInUp"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="close-enquiry-btn"
              onClick={() => setIsEnquiryModalVisible(false)}
            >
              <i className="fa-solid fa-xmark"></i>
            </button>
            <h2>Plan Your Dream Trip</h2>
            <p>
              Drop your details below and our travel experts will get in touch
              with you shortly.
            </p>

            {sendResult === "success" ? (
              <div className="form-success-msg">
                <i className="fa-solid fa-circle-check"></i>
                <p>Thank you! Your enquiry has been sent successfully.</p>
              </div>
            ) : sendResult === "error" ? (
              <div className="form-error-msg">
                <i className="fa-solid fa-circle-exclamation"></i>
                <p>Oops! Something went wrong. Please try again later.</p>
              </div>
            ) : (
              <form
                ref={formRef}
                onSubmit={sendEmail}
                className="quick-enquiry-form"
              >
                <div className="form-group">
                  <input
                    type="text"
                    name="user_name"
                    placeholder="Full Name"
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    name="user_email"
                    placeholder="Email Address"
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="tel"
                    name="user_phone"
                    placeholder="Phone Number"
                    required
                  />
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    placeholder="Where would you like to travel?"
                    rows="3"
                    required
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="submit-enquiry-btn"
                  disabled={isSending}
                >
                  {isSending ? "Sending..." : "Submit Enquiry"}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingContact;
